module.exports = __webpack_public_path__ + "static/media/otp-icon.2290d014.svg";